import { useTheme } from '@mui/material/styles';
import { Toaster as HotToaster } from 'react-hot-toast';

export const Toaster = () => {
  const theme = useTheme();

  return (
    <HotToaster
      position="bottom-right"
      toastOptions={{
        style: {
          backdropFilter: 'blur(6px)',
          background: `rgba(${theme.vars.palette.neutral['900Channel']} / 0.8)`,
          color: theme.vars.palette.common.white,
          boxShadow: theme.shadows[16],
          fontFamily: 'Roboto Flex',
        },
        success: {
          iconTheme: {
            primary: theme.vars.palette.success.main,
            secondary: theme.vars.palette.success.darkest || '#000',
          },
        },
        error: {
          iconTheme: {
            primary: theme.vars.palette.error.main,
            secondary: theme.vars.palette.error.darkest || '#000',
          },
        },
      }}
    />
  );
};
